export default "__VITE_ASSET__DnhGtacd__"